import ProTextInput from "../../../../Components/Inputs/TextField";
import FormSectionWrapper from "../../../../Components/ProForms/FormSectionWrapper";


const ProjectSiteStructureInfoSection = ({
  defaultFormProps,
  formConfig,
  permissions,
}) => {
  const fieldPermission = key => permissions.fieldPerObj[formConfig[key].perKey];

  const fields = [
    "structureSelected",
    "structureManufacturer",
    "rowCount",
    "pileAmount",
    "pileType",
    "pileEmbedmentDepth",
    "blowMinCountRange",
    "blowMaxCountRange",
  ];

  return (
    permissions.canView && (
      <FormSectionWrapper collapsible defaultClose title="Project Site: Structure Info">
        {fields.map(key => {
          const config = formConfig[key];
          return (
            <ProTextInput
              key={key}
              {...defaultFormProps}
              {...config}
              permission={fieldPermission(key)}
            />
          );
        })}
      </FormSectionWrapper>
    )
  );
};

export default ProjectSiteStructureInfoSection;
